import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/views/login/index';
import NotFound from '@/views/404';
Vue.use(Router);
export var constantRoutes = [{
  path: '/login',
  component: Login,
  hidden: true
}, {
  path: '/404',
  component: NotFound,
  hidden: true
}];
export var asyncRoutes = [
// 404 page must be placed at the end !!!
{
  path: '*',
  redirect: '/404',
  hidden: true
}];
var createRouter = function createRouter() {
  return new Router({
    mode: 'hash',
    // require service support
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();

// 全局路由守卫
router.beforeEach(function (to, from, next) {
  next(); // 必须使用 next ,执行效果依赖 next 方法的调用参数
});

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;